import { baseApi } from "./api"
import { parseStringPromise } from 'xml2js'
import { arrayMax, arrayMin } from "../utils/arrayUtils";

const mapsApi = baseApi.enhanceEndpoints({ addTagTypes: ['MapUris', 'MapMetadatas'] }).injectEndpoints({
    endpoints: (builder) => ({
        getMapUri: builder.query({
            query: (id) => `map/${id}/asset-url`,
            transformResponse: (data) => data.uri,
            providesTags: (result, error, arg) => [{ type: 'MapUris', id: arg }],
        }),
        getMapMetadata: builder.query({
            // query: (mapBaseUri) => ,
            query: (mapBaseUri) => ({
                // the .. in the url brings us out of /api and back to the server root /
                url: `..${mapBaseUri}/tiles/tilemapresource.xml`,
                method: 'GET',
                headers: {
                    'Accept': 'application/xml',
                },
                responseHandler: "text",
            }),
            transformResponse: (text) => {
                return parseStringPromise(text, { parseNumbers: true })
                    // .then(data =>{console.debug(data); return data;})
                    .then(data => Promise.resolve({
                        rasterBounds: [
                            // note! rather bounds are reversed! raster is x,y not y,x like latlng
                            Math.abs(data.TileMap.BoundingBox[0].$.maxx),
                            Math.abs(data.TileMap.BoundingBox[0].$.miny),
                        ],
                        center: [
                            (parseFloat(data.TileMap.BoundingBox[0].$.miny) + parseFloat(data.TileMap.BoundingBox[0].$.maxy)) / 2,
                            (parseFloat(data.TileMap.BoundingBox[0].$.minx) + parseFloat(data.TileMap.BoundingBox[0].$.maxx)) / 2,
                        ],
                        bounds: [
                            [parseFloat(data.TileMap.BoundingBox[0].$.miny), parseFloat(data.TileMap.BoundingBox[0].$.minx)],
                            [parseFloat(data.TileMap.BoundingBox[0].$.maxy), parseFloat(data.TileMap.BoundingBox[0].$.maxx)],
                        ],
                        minZoom: arrayMin(data.TileMap.TileSets[0].TileSet.map(TileSet=>parseInt(TileSet.$.href))),
                        maxZoom: arrayMax(data.TileMap.TileSets[0].TileSet.map(TileSet=>parseInt(TileSet.$.href))),
                        tileFormat: {
                            width: parseInt(data.TileMap.TileFormat[0].$.width),
                            height: parseInt(data.TileMap.TileFormat[0].$.height),
                        }
                    }))
                    .then(data =>{console.debug('parsed map metadata:', data); return data;});
            },
            providesTags: (result, error, arg) => [{ type: 'MapMetadatas', id: arg }],
        }),
    }),
})

export const {
    useGetMapUriQuery,
    useGetMapMetadataQuery,
} = mapsApi